export class Notificationpreferenceset {
    projectturnsoverdue:boolean;
    memberfarbehind:boolean;
    newproject:boolean;
    newdeal:boolean;
    projectdisabed:boolean;
    projectreenabled:boolean;
    projectdeleted:boolean;
}